import api from '../../../../../configurations/service';
import * as types from './mutation-types';

export const setNaturezaCollectionForPurchase = async (context) => {
  if (context.state.naturezaCollection && context.state.naturezaCollection.length > 0) {
    return;
  }

  const body = { isEntry: true, onlyActive: true };
  const { data } = await api().post('fiscal.get-natureza', body);
  const naturezaCollection = data.map((e) => ({ ...e, text: e.descricao, value: e, cfop: e.CFOP }));
  context.commit(types.SET_NATUREZA_COLLECTION, naturezaCollection);
};
